import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { quoteFormSelector } from 'ctm-selectors';
import { SummaryTable } from '../summary_table';

const path = 'commencement_date';

const _SummaryCommencementDate = (props) => {
    const { commencementDate, isUpdated } = props;

    const startDate = [
        {
            title: 'Date',
            value: moment(commencementDate).format('DD/MM/YYYY') || ''
        }
    ];

    return (
        <SummaryTable
            isUpdated={isUpdated}
            path={path}
            titleLabel={`Commencement Date ${isUpdated ? '- Updated' : ''}`}
            tableContent={startDate}
        />
    );
};

const mapStateToProps = (state) => {
    return {
        commencementDate: quoteFormSelector(state).getIn(['coverDetail', 'commencementDate']) || '',
        isUpdated: state.getIn(['vertical', 'quote', 'form', `summaryPageEdit${path}`])
    };
};

_SummaryCommencementDate.propTypes = {
    commencementDate: PropTypes.string,
    isUpdated: PropTypes.bool
};

const SummaryCommencementDate = connect(
    mapStateToProps,
)(_SummaryCommencementDate);

export { _SummaryCommencementDate, SummaryCommencementDate };
